module.exports = __webpack_public_path__ + "static/img/product.1f99b81b.png";